import { CHANNELS } from "../shared/channels";
import { UserSettings } from "../shared/types";
import { call } from "./bridge";
import { cachedSettings, rememberSettings } from "./settings_cache";

// the refs this person starred, by ref id, saved per person as refFavorites in their settings.
// the refs themselves are shared, so the stars never touch the shared index

let starred = new Set<string>();
let loaded: Promise<void> | null = null;
let saveTimer = 0;
const watchers: Array<() => void> = [];

function tidy(list: unknown): string[] {
  if (!Array.isArray(list)) return [];
  return [...new Set(list.filter((id): id is string => typeof id === "string" && Boolean(id)))];
}

export function onRefFavoritesChanged(watcher: () => void): void {
  watchers.push(watcher);
}

function save(): void {
  window.clearTimeout(saveTimer);
  saveTimer = window.setTimeout(() => {
    void call<UserSettings>(CHANNELS.settingsSave, { refFavorites: [...starred] }).then(rememberSettings).catch(() => undefined);
  }, 350);
}

export function loadRefFavorites(): Promise<void> {
  loaded ??= cachedSettings()
    .then((settings) => {
      starred = new Set(tidy(settings.refFavorites));
      watchers.forEach((watcher) => watcher());
    })
    .catch(() => {
      loaded = null;
    });
  return loaded;
}

export function isRefFavorite(id: string): boolean {
  return starred.has(id);
}

export function toggleRefFavorite(id: string): boolean {
  if (starred.has(id)) starred.delete(id);
  else starred.add(id);
  watchers.forEach((watcher) => watcher());
  save();
  return starred.has(id);
}

// paints a star button to match, shared by the tiles, posts and the lightbox
export function paintStar(button: HTMLElement, id: string): void {
  const on = starred.has(id);
  button.textContent = on ? "★" : "☆";
  button.setAttribute("aria-pressed", String(on));
  button.classList.toggle("on", on);
}
